export enum AffiliationType {
  /**
   * Senior
   */
  Senior = 'senior',

  /**
   * Caregiver
   */
  Caregiver = 'caregiver',

  // TODO: this needs to be revised by the end of the roles & permissions refactor; the new allowed types will be
  // "senior" and "caregiver", so the values below must be deleted at some point.
  // Reference: https://dev.api.sios.life/#cmp--schemas-affiliationtype.

  /**
   * Administrator
   * @deprecated
   */
  Administrator = 'administrator',

  /**
   * Manager
   * @deprecated
   */
  Manager = 'manager',

  /**
   * Operator
   * @deprecated
   */
  Operator = 'operator',

  /**
   * Medical Data
   * @deprecated
   */
  MedicalProfessional = 'medical-professional',
}
